import 'ant-design-vue/dist/antd.less';
import '@surely-vue/table/dist/index.css';
import {
  Layout,
  Affix,
  Menu,
  Row,
  Col,
  Card,
  Form,
  Dropdown,
  Calendar,
  Select,
  Button,
  Checkbox,
  Tabs,
  Tag,
  Input,
  InputNumber,
  DatePicker,
  TimePicker,
  Radio,
  Tooltip,
  Space,
  Steps,
  Divider,
  Descriptions,
  Alert,
  Result,
  Statistic,
  Popconfirm,
  Popover,
  Table,
  Avatar,
  List,
  Progress,
  Switch,
  Modal,
  Rate,
  ConfigProvider,
  Empty,
  Spin,
  Drawer,
  PageHeader,
  Carousel,
  BackTop,
  Upload,
  Badge,
  TreeSelect,
  Slider,
  Tree,
  Image,
  Breadcrumb,
  Cascader,
} from 'ant-design-vue';
import SurelyTable from '@surely-vue/table';
const Print = require('vue3-print-nb/dist/vue3-print-nb.umd.js');
import { createApp } from 'vue';
import router from './router';
import store from './store';
import locale from './locales';
import App from './App.vue';

import FormDesign from '@/components/FormDesign';
import UploadImageModal from '@/components/form-modal/upload_image_modal/index.vue';
import DoubleImageInfoModal from '@/components/info-modal/double_image_info_modal.vue';
import DoubleImageEditModal from '@/components/form-modal/double_image_edit_modal/double_image_edit_modal.vue';
import SearchRender from '@/components/FormRender/SearchRender.vue';
import RemoteSelect from '@/components/FormRender/RemoteSelect/RemoteSelect.vue';
import RemoteModal from '@/components/FormRender/RemoteModal/RemoteModal.vue';
import ProjectSet from '@/components/form-modal/projectsetmodel/projectsetmodel.vue';
import SelectMjstoreOrderusedrecord from '@/components/form-modal/customSelecteModal/select-mjstore-orderusedrecord.vue';
import Orderusedrecordmodel from '@/components/form-modal/orderusedrecordmodel/orderusedrecordmodel.vue';
import Setrecordmodel from '@/components/form-modal/setrecordmodel/setrecordmodel.vue';
import Shopoperationtargetmodel from '@/components/form-modal/shopoperationtargetmodel/shopoperationtargetmodel.vue';
import Staffoperationtargetmodel from '@/components/form-modal/staffoperationtargetmodel/staffoperationtargetmodel.vue';
import StaffWorkModel from '@/components/form-modal/staffwork/staffworkmodel.vue';
import FieldRender from '@/components/FormRender/FieldRender.vue';
import ExportExcelModal from '@/components/info-modal/export-excel-modal/index.vue';
import Receiptrecordmodel from '@/components/form-modal/receiptrecordmodel/receiptrecordmodel.vue';
import Printcustomerremainmodel from '@/components/form-modal/Printcustomerremainmodel/index.vue';
import ExtendCardRecordModel from '@/components/form-modal/extendCardRecordModel/index.vue';
import TipsModal from '@/components/form-modal/tips_modal.vue';
import TablePageModal2 from '@/components/form-modal/table_page_modal2.vue';
import PageModel4 from '@/components/page-model4/index.vue';
import JSONEdit from '@/components/form-modal/jsonEditModal/index.vue';
import JSONEditModal from '@/components/form-modal/jsonEditModal/jsonEditModal.vue';
import Cell_index from '@/components/cellComponent/cell_index.vue';
import Cell_custom from '@/components/cellComponent/cell_custom.vue';
import Cell_custom1 from '@/components/cellComponent/cell_custom1.vue';
import Cell_datetime from '@/components/cellComponent/cell_datetime.vue';
import Cell_date from '@/components/cellComponent/cell_date.vue';
import Cell_date_month from '@/components/cellComponent/cell_date_month.vue';
import Cell_month from '@/components/cellComponent/cell_month.vue';
import Cell_time from '@/components/cellComponent/cell_time.vue';
import Cell_percent from '@/components/cellComponent/cell_percent.vue';
import Cell_toFixed2 from '@/components/cellComponent/cell_toFixed2.vue';
import Cell_money from '@/components/cellComponent/cell_money.vue';
import Cell_money2 from '@/components/cellComponent/cell_money2.vue';
import Cell_attributetable from '@/components/cellComponent/cell_attributetable.vue';
import Cell_click from '@/components/cellComponent/cell_click.vue';
import Cell_click1 from '@/components/cellComponent/cell_click1.vue';
import Cell_color from '@/components/cellComponent/cell_color.vue';
import Cell_boolean from '@/components/cellComponent/cell_boolean.vue';
import Cell_list from '@/components/cellComponent/cell_list.vue';
import Cell_list1 from '@/components/cellComponent/cell_list1.vue';
import Cell_tag from '@/components/cellComponent/cell_tag.vue';
import Cell_real_weight from '@/components/cellComponent/cell_real_weight.vue';
import Cell_weight_offset_percent from '@/components/cellComponent/cell_weight_offset_percent.vue';
import Cell_collect_status from '@/components/cellComponent/cell_collect_status.vue';
import Cell_send_robot from '@/components/cellComponent/cell_send_robot.vue';
import Cell_tag_tag from '@/components/cellComponent/cell_tag-tag.vue';
import Cell_progress from '@/components/cellComponent/cell_progress.vue';
import Cell_bind_no from '@/components/cellComponent/cell_bind_no.vue';
import Cell_action from '@/components/cellComponent/cell_action.vue';
import Cell_stop_tag from '@/components/cellComponent/cell_stop_tag.vue';
import Cell_report_tag from '@/components/cellComponent/cell_report_tag.vue';
import Cell_text from '@/components/cellComponent/cell_text.vue';
import Cell_obj from '@/components/cellComponent/cell_obj.vue';
import Cell_bolder from '@/components/cellComponent/cell_bolder.vue';
import Cell_share_tag from '@/components/cellComponent/cell_share_tag.vue';
import Cell_script_log from '@/components/cellComponent/cell_script_log.vue';
import Cell_click_copy from '@/components/cellComponent/cell_click_copy.vue';
import Cell_click_order from '@/components/cellComponent/cell_click_order.vue';
import Cell_technicsinfolist from '@/components/cellComponent/cell_technicsinfolist.vue';
import Cell_menu_list from '@/components/cellComponent/cell_menu_list.vue';
import Cell_json_modal from '@/components/cellComponent/cell_json_modal.vue';
import headerComponentMjstoreCustomerListWithCustomerType from '@/components/headerComponent/headerComponent_mjstore-customer_list_with_customer_type.vue';

import {
  ProProvider,
  PageContainer,
  TransformVnode,
  PageContainer2,
  PageContainer3,
} from '@/components';
import { useIcons } from '@/icons';
import Authority from './utils/authority/authority.vue';
import './app.less';
import './router/router-guards';
import bus from './utils/bus';
// import * as Sentry from '@sentry/vue';
// import { Integrations } from '@sentry/tracing';
import { setLicenseKey } from '@surely-vue/table';

// if (process.env.NODE_ENV == 'production') {
//   Sentry.init({
//     dsn: 'http://20b30fe654f643c7bf14d9ebd8b056ea@8.140.118.52:19000/6',
//     integrations: [new Integrations.BrowserTracing()],
//
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//   });
// }
setLicenseKey(
  '7e739ffcce912bfb784bd89279d2272bT1JERVI6MTAwMDA5LEVYUElSWT0xNjc3MjgzMjAwMDAwLERPTUFJTj1zdXJlbHkuY29vbCxVTFRJTUFURT0xLEtFWVZFUlNJT049MQ==',
);

const app = createApp(App);
app.config.globalProperties.$bus = bus;

app
  .use(router)
  .use(locale as any)
  .use(store)
  .use(Affix)
  .use(Layout)
  .use(Menu)
  .use(Row)
  .use(Col)
  .use(Card)
  .use(Form)
  .use(Dropdown)
  .use(Select)
  .use(Calendar)
  .use(Button)
  .use(Checkbox)
  .use(Tabs)
  .use(Tag)
  .use(Input)
  .use(Image)
  .use(InputNumber)
  .use(DatePicker)
  .use(TimePicker)
  .use(Radio)
  .use(Tooltip)
  .use(Space)
  .use(Steps)
  .use(Divider)
  .use(Descriptions)
  .use(Alert)
  .use(Result)
  .use(Statistic)
  .use(Popconfirm)
  .use(Popover)
  .use(Table)
  .use(Avatar)
  .use(List)
  .use(Progress)
  .use(Switch)
  .use(Modal)
  .use(Rate)
  .use(ConfigProvider)
  .use(Empty)
  .use(Spin)
  .use(Drawer)
  .use(PageHeader)
  .use(TreeSelect)
  .use(ProProvider)
  .use(Slider)
  .use(FormDesign)
  .use(Badge)
  .use(Carousel)
  .use(BackTop)
  .use(Upload)
  .use(Tree)
  .use(Breadcrumb)
  .use(Cascader)
  .use(SurelyTable as any)
  .use(Print)
  .component(PageContainer.name, PageContainer)
  .component(PageContainer2.name, PageContainer2)
  .component(PageContainer3.name, PageContainer3)
  .component(TransformVnode.name, TransformVnode)
  .component(Authority.name, Authority)
  .component(FieldRender.name, FieldRender)
  .component(SearchRender.name, SearchRender)
  .component(UploadImageModal.name, UploadImageModal)
  .component(DoubleImageInfoModal.name, DoubleImageInfoModal)
  .component(DoubleImageEditModal.name, DoubleImageEditModal)
  .component(RemoteSelect.name, RemoteSelect)
  .component(TablePageModal2.name, TablePageModal2)
  .component(ProjectSet.name, ProjectSet)
  .component(Orderusedrecordmodel.name, Orderusedrecordmodel)
  .component(Setrecordmodel.name, Setrecordmodel)
  .component(Shopoperationtargetmodel.name, Shopoperationtargetmodel)
  .component(Staffoperationtargetmodel.name, Staffoperationtargetmodel)
  .component(StaffWorkModel.name, StaffWorkModel)
  .component(RemoteModal.name, RemoteModal)
  .component(SelectMjstoreOrderusedrecord.name, SelectMjstoreOrderusedrecord)
  .component(ExportExcelModal.name, ExportExcelModal)
  .component(Receiptrecordmodel.name, Receiptrecordmodel)
  .component(Printcustomerremainmodel.name, Printcustomerremainmodel)
  .component(ExtendCardRecordModel.name, ExtendCardRecordModel)
  .component(TipsModal.name, TipsModal)
  .component(PageModel4.name, PageModel4)
  .component(Cell_index.name, Cell_index)
  .component(Cell_custom.name, Cell_custom)
  .component(Cell_custom1.name, Cell_custom1)
  .component(Cell_datetime.name, Cell_datetime)
  .component(Cell_date.name, Cell_date)
  .component(Cell_date_month.name, Cell_date_month)
  .component(Cell_month.name, Cell_month)
  .component(Cell_time.name, Cell_time)
  .component(Cell_percent.name, Cell_percent)
  .component(Cell_toFixed2.name, Cell_toFixed2)
  .component(Cell_money.name, Cell_money)
  .component(Cell_money2.name, Cell_money2)
  .component(Cell_attributetable.name, Cell_attributetable)
  .component(Cell_click.name, Cell_click)
  .component(Cell_click1.name, Cell_click1)
  .component(Cell_color.name, Cell_color)
  .component(Cell_boolean.name, Cell_boolean)
  .component(Cell_list.name, Cell_list)
  .component(Cell_list1.name, Cell_list1)
  .component(Cell_tag.name, Cell_tag)
  .component(Cell_real_weight.name, Cell_real_weight)
  .component(Cell_weight_offset_percent.name, Cell_weight_offset_percent)
  .component(Cell_collect_status.name, Cell_collect_status)
  .component(Cell_send_robot.name, Cell_send_robot)
  .component(Cell_tag_tag.name, Cell_tag_tag)
  .component(Cell_progress.name, Cell_progress)
  .component(Cell_bind_no.name, Cell_bind_no)
  .component(Cell_action.name, Cell_action)
  .component(Cell_stop_tag.name, Cell_stop_tag)
  .component(Cell_report_tag.name, Cell_report_tag)
  .component(Cell_text.name, Cell_text)
  .component(Cell_obj.name, Cell_obj)
  .component(Cell_bolder.name, Cell_bolder)
  .component(Cell_share_tag.name, Cell_share_tag)
  .component(Cell_script_log.name, Cell_script_log)
  .component(Cell_click_copy.name, Cell_click_copy)
  .component(Cell_click_order.name, Cell_click_order)
  .component(Cell_technicsinfolist.name, Cell_technicsinfolist)
  .component(Cell_menu_list.name, Cell_menu_list)
  .component(Cell_json_modal.name, Cell_json_modal)
  .component(JSONEdit.name, JSONEdit)
  .component(JSONEditModal.name, JSONEditModal)
  .component(
    headerComponentMjstoreCustomerListWithCustomerType.name,
    headerComponentMjstoreCustomerListWithCustomerType,
  );
useIcons(app);

app.mount('#app');
